<template>
  <a-modal :title="follow_type===2?'标黑':'标无效'" @ok="save" v-model="visible" :destroyOnClose="true">
    <a-form :form="form">
      <a-form-item>
        <a-textarea
          :placeholder="placeholder"
          :rows="6"
          v-decorator="[
            'remark',
            { rules: [{ required: true, message: '请填写备注' }] }
          ]"
        ></a-textarea>
      </a-form-item>
    </a-form>
    <div class="warn" v-if="follow_type === 3">“标无效”的猎头将被移入“无效猎头”池！</div>
  </a-modal>
</template>
<script>
import BaseModal from "@/components/base-modal";
export default {
  name: "RemarkModal",
  extends: BaseModal,
  data() {
    return {
      form: this.$form.createForm(this),
      record: '',
      follow_type: '',
      placeholder: '',
    };
  },
  methods: {
    save(confirm) {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true;
          this.$emit("ok", values.remark, this.record, this.follow_type);
        }
      });
    },
    async show(record, follow_type) {
      this.record = record;
      this.follow_type = follow_type;
      if(follow_type === 2) {
        this.placeholder = '请在此处添加备注信息';
      } else {
        this.placeholder = '请在此处添加你标无效的理由：\n合理的运用“标无效”操作有助于您更好的服务于优质猎头，在您跟进猎头中如发现有虚假猎头，可进行此操作';
      }
      this.open();
    }
  }
};
</script>

<style scoped lang="scss">

  .warn {
    position: absolute;
    bottom: 15px;
    left: 16px;
    color: red;

  }
</style>
